import Ky from 'ky';
import type { KyInstance, Options } from 'ky';

import { config } from '../../config';

import { ensureClientBucketCookie } from './utils';

interface SPSResponse {
  data: {
    campaign: string;
    content: string;
  };
}

const normalizeResponse = (response: SPSResponse) => {
  const { campaign, content } = response.data;

  return {
    html: content,
    campaign,
  };
};

export type Salesposter = ReturnType<typeof normalizeResponse>;

const getSalesposter =
  (client: KyInstance) =>
  async (
    {
      section = 'default',
      placement,
      userId,
      refId,
    }: {
      section?: string;
      placement: string;
      userId?: string | null;
      refId?: string;
    },
    options?: Options
  ): Promise<Salesposter> => {
    const params = new URLSearchParams();

    if (userId) {
      params.set('spid', userId);
    }

    let url = `salesposter/${section}/${placement}`;

    if (refId) {
      url += `/${refId}`;
    }

    ensureClientBucketCookie();

    const response = await client
      .get(url, { ...options, searchParams: params })
      .json<SPSResponse>();

    return normalizeResponse(response);
  };

const createSpsApi = (client: KyInstance) => {
  return {
    getSalesposter: getSalesposter(client),
  };
};

export const spsApi = createSpsApi(
  Ky.create({
    prefixUrl: config.spsApiHostname,
    credentials: 'include',
  })
);
